export interface DeepgramVoice {
  id: string;
  accent: string;
  gender: string;
}

export enum DeepgramGender {
  male = 'male',
  female = 'female',
}

/**
 *
 * aura-angus-en    [Irish, male]
 * aura-arcas-en    [American, male]
 * aura-asteria-en  [American, female]
 * aura-athena-en   [British, female]
 * aura-helios-en   [British, male]
 * aura-hera-en     [American, female]
 * aura-luna-en     [American, female]
 * aura-orion-en    [American, male]
 * aura-orpheus-en  [American, male]
 * aura-perseus-en  [American, male]
 * aura-stella-en   [American, female]
 * aura-zeus-en     [American, male]
 *
 */
export const deepgramVoiceList: DeepgramVoice[] = [
  { id: 'aura-angus-en', accent: 'Irish', gender: 'Male' },
  { id: 'aura-arcas-en', accent: 'American', gender: 'Male 1' },
  { id: 'aura-asteria-en', accent: 'American', gender: 'Female 1' },
  { id: 'aura-athena-en', accent: 'British', gender: 'Female' },
  { id: 'aura-helios-en', accent: 'British', gender: 'Male' },
  { id: 'aura-hera-en', accent: 'American', gender: 'Female 2' },
  { id: 'aura-luna-en', accent: 'American', gender: 'Female 3' },
  { id: 'aura-orion-en', accent: 'American', gender: 'Male 2' },
  { id: 'aura-orpheus-en', accent: 'American', gender: 'Male 3' },
  { id: 'aura-perseus-en', accent: 'American', gender: 'Male 4' },
  { id: 'aura-stella-en', accent: 'American', gender: 'Female 4' },
  { id: 'aura-zeus-en', accent: 'American', gender: 'Male 5' },
];

export function getDeepgramVoiceById(id?: string): DeepgramVoice | undefined {
  return deepgramVoiceList.find((voice) => voice.id === id);
}
